<template>
  <div>
    <div class="page_title flex_between">
      <span>编辑文章</span>
      <span>
        <el-button
          type="primary"
          style="width: 100px; margin-right: 10px"
          @click="submit"
        >保存</el-button>
        <el-button
          style="width: 100px"
          @click="back"
          type="plain"
        >退出</el-button>
      </span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <span style="margin-right: 20px">标题</span>
          <el-input
            v-model="title"
            style="width: 375px"
            maxlength="30"
          ></el-input>
        </div>
        <div style="margin: 20px 0">
          <span style="margin-right: 20px">作者</span>
          <el-input
            v-model="author"
            style="width: 375px"
            maxlength="10"
          ></el-input>
        </div>
        <div
          class="flex"
          style="margin: 20px 0 30px"
        >
          <div style="margin-right: 20px">主图</div>
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="pic"
                :src="pic_url"
                class="avatar"
              />
              <div v-else>
                <i class="el-icon-circle-plus uploader-icon"></i>
                <div style="color: #8c99a4; font-weight: 600; margin: 16px 0 8px">
                  请上传图片
                </div>
                <div style="width: 130px; color: #a9b4b6; font-size: 12px">
                  支持jpg, png, jpeg格式 最佳尺寸750x410
                </div>
              </div>
              <div
                class="delimg"
                @click="delImg"
                v-if="pic"
              >
                <i class="el-icon-delete-solid"></i>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="type">内容编辑</div>
        <div style="width: 70%; height: 100%">
          <wangeditorNew
            ref="editorBox"
            @changeCheck="changeCheck"
            :margins="margins"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constant from '../../../service/common/constant';
import wangeditorNew from '../wangeditorNew';

export default {
  data() {
    return {
      pic: '',
      pic_url: '',
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      },
      title: '',
      author: '',
      info_id: '',
      margins: 1
    };
  },
  components: {
    wangeditorNew
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  methods: {
    //获取详情
    getDetail() {
      let info_id = this.info_id;
      this.axios
        .post('platform/library/getFamousDoctorTalkInfo', { info_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.title = info.title;
            this.author = info.author;
            this.margins = info.margins;
            this.pic = info.pic;
            this.pic_url = info.pic_str;
            this.setDesc(info.content);
          }
        });
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.setHtml(text);
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        //半路径
        this.pic = res.data.pic;
        //绝对路径
        this.pic_url = res.data.path;
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    //删除图片
    delImg() {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.pic = '';
      this.pic_url = '';
    },
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    //保存/发布
    submit() {
      if (!this.title || !this.author) {
        this.$message.error('请填写文章信息');
        return false;
      }
      if (!this.pic) {
        this.$message.error('请上传主图');
        return false;
      }
      let content = this.$refs.editorBox.editor.getHtml();
      if (!content) {
        this.$message.error('请填写文章内容');
        return false;
      }
      let data = {};
      let url = 'platform/library/saveFamousDoctorTalkInfo';
      if (this.info_id) {
        data = {
          pic: this.pic,
          title: this.title,
          author: this.author,
          info_id: this.info_id,
          margins: this.margins,
          content: content
        };
        url = 'platform/library/editFamousDoctorTalkInfo';
      } else {
        data = {
          pic: this.pic,
          title: this.title,
          author: this.author,
          content: content
        };
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功');
          this.back();
        }
      });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.margins = 1;
    if (this.$route.query.info_id) {
      this.info_id = this.$route.query.info_id;
      this.getDetail();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.type {
  font-weight: 600;
}
.imgbox {
  width: 375px;
  height: 205px;
  background-color: #eff3f5;
  box-shadow: inset 2px 2px 4px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: dashed 1px #b8c4ce;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;

  .avatar {
    width: 375px;
    height: 205px;
  }
  .uploader-icon {
    font-size: 60px;
    color: #36af71;
  }
  .delimg {
    box-sizing: border-box;
    display: none;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: rgba($color: #fff, $alpha: 0.6);
    font-size: 40px;
    color: #e74c3d;
  }
  &:hover {
    .delimg {
      display: block;
    }
  }
}
</style>